export { default as default } from './KitEditableAvatar';
